export function BadIcon() {
    return (
        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.82904 0.975191C1.41062 0.556772 0.732233 0.556772 0.313814 0.975191C-0.104605 1.39361 -0.104605 2.072 0.313814 2.49042L2.98477 5.16138L0.313814 7.83233C-0.104605 8.25075 -0.104605 8.92914 0.313814 9.34756C0.732233 9.76598 1.41062 9.76598 1.82904 9.34756L4.5 6.67661L7.17096 9.34756C7.58938 9.76598 8.26777 9.76598 8.68619 9.34756C9.1046 8.92914 9.1046 8.25075 8.68619 7.83233L6.01523 5.16138L8.68619 2.49042C9.1046 2.072 9.1046 1.39361 8.68619 0.975191C8.26777 0.556772 7.58938 0.556772 7.17096 0.975191L4.5 3.64615L1.82904 0.975191Z" fill="currentColor" />
        </svg>

    )
}

export function CorrectIcon() {
    return (
        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.5816 0.430992C14.1395 0.988884 14.1395 1.89341 13.5816 2.4513L5.92087 10.112C5.36298 10.6699 4.45845 10.6699 3.90056 10.112L0.418419 6.62987C-0.139473 6.07198 -0.139473 5.16746 0.418419 4.60956C0.976311 4.05167 1.88083 4.05167 2.43872 4.60956L4.91071 7.08155L11.5613 0.430992C12.1192 -0.1269 13.0237 -0.1269 13.5816 0.430992Z" fill="currentColor" />
        </svg>

    )
}